import { render, staticRenderFns } from "./TellusStory.vue?vue&type=template&id=4a361266"
import script from "./TellusStory.vue?vue&type=script&lang=js"
export * from "./TellusStory.vue?vue&type=script&lang=js"
import style0 from "./TellusStory.vue?vue&type=style&index=0&id=4a361266&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports